import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from '@app/redux/interface';

export const getAuthFormsState = (state: RootState) => state.authForms;

export const getAuthFormData = createDraftSafeSelector(getAuthFormsState, authFormsState => authFormsState);
